import { Paths, PathValue } from "@mctypes/global.types";
import React from "react";
import { McInputNew, McTextAreaNew } from "../../../../../../components";
import McDropdownNew from "../../../../../../components/McDropdown/MCDropdownNew";
import { KontrollAvLuftstroemEnum } from "@mcapps/shared/gkReportConstants";
import { Radio, Paper, Stack, Title, Box } from "@mantine/core";import {  IGKKontrollAvLuftStroemVedArbeidsaapningResultater,
  IGKRapport,
} from "@mcapps/shared/reportSchemas/gkReportSchema";
import ReportDocxImageContainer from "../../../ReportBoard/ReportDocxImageContainer";
const KontrollAvLuftstroemVedArbeidsaapning: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKKontrollAvLuftStroemVedArbeidsaapningResultater;
}> = ({ data, onUpdateEditData }) => {
  const TESTMETODER: KontrollAvLuftstroemEnum[] = [
    KontrollAvLuftstroemEnum.STREAMER,
    KontrollAvLuftstroemEnum.ROEYKELLERTAAKE,
  ];
  const valgtMetode = data.inndata.valgtMetode;
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>Kontroll av luftstrøm</Title>
        <b>Hvilken metode skal brukes?</b>
        <div style={{ width: "25%" }}>
          <McDropdownNew
            currentValue={data.inndata.valgtMetode}
            onChange={(_, item) =>
              onUpdateEditData(
                "testResultater.kontrollAvLuftstroemVedArbeidsaapning.inndata.valgtMetode",
                item as string,
              )
            }
            defaultTitle="Hvilken testmetode skal brukes?"
            options={TESTMETODER}
          />
        </div>
        {(valgtMetode === KontrollAvLuftstroemEnum.STREAMER ||
          valgtMetode === KontrollAvLuftstroemEnum.ROEYKELLERTAAKE) && (
          <Box mt="lg" style={{ width: "50%" }}>
            <div>
              <McTextAreaNew
                label="Beskrivelse av luftstrøm:"
                value={data.inndata.resultater.beskrivelseAvLuftstroem}
                onChange={(e) =>
                  onUpdateEditData(
                    "testResultater.kontrollAvLuftstroemVedArbeidsaapning.inndata.resultater.beskrivelseAvLuftstroem",
                    e.target.value,
                  )
                }
              />
            </div>
            <div>
              <Stack gap={0}>
                                <Radio
                  checked={data.inndata.resultater.godkjent === true}
                  onChange={() =>
                  onUpdateEditData(
                  "testResultater.kontrollAvLuftstroemVedArbeidsaapning.inndata.resultater.godkjent",
                  true,
                  )
                  }
                  label="Godkjent"
                />
                                <Radio
                  checked={data.inndata.resultater.godkjent === false}
                  onChange={() =>
                  onUpdateEditData(
                  "testResultater.kontrollAvLuftstroemVedArbeidsaapning.inndata.resultater.godkjent",
                  false,
                  )
                  }
                  label="Ikke godkjent"
                />
              </Stack>
            </div>
          </Box>
        )}
        <Box mt="lg" style={{ width: "50%" }}>
          <div>
            <ReportDocxImageContainer docxImageTag="kontrollAvLuftstroemVedArbeidsaapning" title="Målepunkter" />
          </div>
          <McTextAreaNew
            label="Kommentar:"
            value={data.inndata.kommentar}
            onChange={(e) =>
              onUpdateEditData("testResultater.kontrollAvLuftstroemVedArbeidsaapning.inndata.kommentar", e.target.value)
            }
          />
        </Box>
      </Stack>
    </Paper>
  );
};
export default KontrollAvLuftstroemVedArbeidsaapning;